import { TaxonomyTheme } from '../implementations';

const mappers = {
  theme: TaxonomyTheme,
};

export default mappers;
